/*
  JD size chart pop-up.
  Data: <script id="jd-sc-data"> from snippets/jd-size-chart.liquid (metaobject size_chart, rows in mm).
  The dialog is built on the first click of a [data-jd-sc-open] trigger; the option label is never touched.
  The selected size is not highlighted (all rows follow the zebra colours).
*/
(function () {
  'use strict';
  if (window.jdSizeChart) return;

  var dataEl = document.getElementById('jd-sc-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[jd-size-chart] invalid chart data', e); return; }

  var STORE_KEY = 'jd-sc-unit';
  var MM_PER_IN = 25.4;
  var columns = Array.isArray(data.columns) ? data.columns : [];
  var allRows = Array.isArray(data.rows) ? data.rows : [];
  var root, panel, thead, tbody, unitButtons, lastTrigger;
  var unit = readUnit();

  function readUnit() {
    var u = null;
    try { u = window.localStorage.getItem(STORE_KEY); } catch (e) {}
    if (u !== 'in' && u !== 'mm') u = String(data.unit || 'in').toLowerCase() === 'mm' ? 'mm' : 'in';
    return u;
  }
  function saveUnit(u) {
    try { window.localStorage.setItem(STORE_KEY, u); } catch (e) {}
  }

  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  // Maat als getal, ongeacht de notatie: "7", "US 7", "Size 7", "7 US", "US7", "7.0" → "7";
  // "7.5", "7,5", "7 1/2", "7½", "US 7.5" → "7.5". Zonder getal: de tekst zelf.
  function sizeKey(v) {
    var s = norm(v).replace(/\u00bd/g, '.5').replace(/,/g, '.');
    var half = s.match(/(\d+)\s+1\/2/);
    if (half) return String(parseFloat(half[1]) + 0.5);
    var m = s.match(/\d+(?:\.\d+)?/);
    return m ? String(parseFloat(m[0])) : s;
  }
  function sameSize(a, b) { return sizeKey(a) === sizeKey(b); }

  // Rows for this product: ONLY the sizes it has as variants (unless "show all"). Never fall back to all sizes:
  // a size that is not in the chart data is left out (console warning).
  var rows = allRows;
  if (!data.showAll) {
    var values = Array.isArray(data.values) ? data.values : [];
    var missing = values.filter(function (v) { return !allRows.some(function (r) { return sameSize(r.size, v); }); });
    if (missing.length) console.warn('[jd-size-chart] sizes without chart data:', missing.join(', '));
    rows = allRows.filter(function (r) { return values.some(function (v) { return sameSize(r.size, v); }); });
  }

  function fmt(mm) {
    var n = parseFloat(mm);
    if (isNaN(n)) return mm == null ? '' : String(mm);
    return unit === 'in' ? (n / MM_PER_IN).toFixed(2) : n.toFixed(1);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function renderTable() {
    var head = '<tr><th scope="col">' + esc(data.sizeLabel) + '</th>';
    columns.forEach(function (c) { head += '<th scope="col">' + esc(c.label) + ' (' + unit + ')</th>'; });
    thead.innerHTML = head + '</tr>';

    var body = rows.length ? '' : '<tr><td colspan="' + (columns.length + 1) + '">Size details for this ring are not available.</td></tr>';
    rows.forEach(function (r) {
      body += '<tr><td>' + esc(r.size) + '</td>';
      columns.forEach(function (c) { body += '<td>' + esc(fmt(r[c.key])) + '</td>'; });
      body += '</tr>';
    });
    tbody.innerHTML = body;

    unitButtons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-unit') === unit ? 'true' : 'false'); });
  }

  function build() {
    var text = '';
    if (data.howTo) text += '<div class="jd-sc__how">' + data.howTo + '</div>';
    if (data.tip) {
      // "Between two sizes? Choose …" → only the question in bold
      var tip = String(data.tip), q = tip.indexOf('?');
      text += '<p class="jd-sc__tip">' + (q > -1 && q < tip.length - 1
        ? '<strong>' + esc(tip.slice(0, q + 1)) + '</strong> ' + esc(tip.slice(q + 1).trim())
        : '<strong>' + esc(tip) + '</strong>') + '</p>';
    }
    if (data.guarantee) text += '<div class="jd-sc__guarantee">' + data.guarantee + '</div>';
    var above = data.textPosition === 'above';
    var textBlock = text ? '<div class="jd-sc__text jd-sc__text--' + (above ? 'above' : 'below') + '">' + text + '</div>' : '';

    root = document.createElement('div');
    root.className = 'jd-sc';
    root.id = 'jd-sc-dialog';
    root.hidden = true;
    root.innerHTML =
      '<div class="jd-sc__backdrop" data-jd-sc-close></div>' +
      '<div class="jd-sc__panel" role="dialog" aria-modal="true" aria-labelledby="jd-sc-title" tabindex="-1">' +
        '<div class="jd-sc__head">' +
          '<div><h2 class="jd-sc__title" id="jd-sc-title">' + esc(data.title) + '</h2>' +
          '<p class="jd-sc__sub">' + esc(data.subtitle) + '</p></div>' +
          '<button type="button" class="jd-sc__close" data-jd-sc-close aria-label="Close">' +
            '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M4 4l12 12M16 4 4 16"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="jd-sc__body">' +
          '<div class="jd-sc__units-row"><div class="jd-sc__units" role="group" aria-label="Units">' +
            '<button type="button" class="jd-sc__unit" data-unit="in" aria-pressed="false">IN</button>' +
            '<button type="button" class="jd-sc__unit" data-unit="mm" aria-pressed="false">MM</button>' +
          '</div></div>' +
          (above ? textBlock : '') +
          '<table class="jd-sc__table"><thead></thead><tbody></tbody></table>' +
          (above ? '' : textBlock) +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    panel = root.querySelector('.jd-sc__panel');
    thead = root.querySelector('thead');
    tbody = root.querySelector('tbody');
    unitButtons = Array.prototype.slice.call(root.querySelectorAll('.jd-sc__unit'));

    root.addEventListener('click', function (e) {
      var u = e.target.closest('.jd-sc__unit');
      if (u) {
        unit = u.getAttribute('data-unit');
        saveUnit(unit);
        renderTable();
        return;
      }
      if (e.target.closest('[data-jd-sc-close]')) close();
    });
    root.addEventListener('keydown', onKeydown);
    renderTable();
  }

  var closeTimer;
  var scrollbarPad = '';
  function lockScroll() {
    var sb = window.innerWidth - document.documentElement.clientWidth;
    scrollbarPad = document.body.style.paddingRight;
    if (sb > 0) document.body.style.paddingRight = sb + 'px';
    document.documentElement.classList.add('jd-sc-locked');
  }
  function unlockScroll() {
    document.documentElement.classList.remove('jd-sc-locked');
    document.body.style.paddingRight = scrollbarPad;
  }

  function open(trigger) {
    lastTrigger = trigger || lastTrigger;
    if (!root) build();
    clearTimeout(closeTimer);
    if (!root.hidden && root.classList.contains('is-open')) return;
    root.hidden = false;
    lockScroll();
    void root.offsetWidth; // start the transition from the hidden state
    root.classList.add('is-open');
    if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'true');
    panel.focus({ preventScroll: true });
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus({ preventScroll: true });
    }
    closeTimer = setTimeout(function () {
      root.hidden = true;
      unlockScroll();
    }, 300);
  }

  function onKeydown(e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(panel.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-jd-sc-open]');
    if (!t) return;
    e.preventDefault();
    open(t);
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && root && !root.hidden && root.classList.contains('is-open')) { e.preventDefault(); close(); }
  });

  window.jdSizeChart = { open: open, close: close, data: data };
})();
